// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"c4741284","238":"6ba5db8f","455":"a78a3dc5"}[chunkId] + ".chunk.js";
};